import React, { useState } from 'react';
import ModuleSection from './ModuleSection';
import { toast } from '@getpingback/realeza';
import { Button } from '@material-ui/core';
import { PlusIcon } from '@stash-ui/regular-icons';
import NewModuleModal from './NewModuleModal';
import DeleteModal from './DeleteModal';
import { deleteModule } from '../../../services/education';

const ModulesSection = ({ modules, courseId, onCreated }) => {
  const [isNewModuleModalOpen, setIsNewModuleModalOpen] = useState({
    isOpen: false,
    moduleData: null,
  });
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState({
    isOpen: false,
    moduleId: null,
  });

  const handleOpenNewModuleModal = () => {
    setIsNewModuleModalOpen({
      isOpen: true,
      moduleData: null,
    });
  };

  const handleDeleteModule = async id => {
    try {
      await deleteModule(id);
      setIsDeleteModalOpen({ isOpen: false, moduleId: null });
      onCreated();
      toast.success('Module deleted successfully');
    } catch (error) {
      console.error(error);
      toast.error(`Error deleting module: ${error?.response?.data?.error?.message}`);
    }
  };

  return (
    <div className="education__course__modules">
      <div className="education__course__modules__header">
        <h2>Modules</h2>
        <Button variant="contained" startIcon={<PlusIcon />} onClick={handleOpenNewModuleModal}>
          Add Module
        </Button>
      </div>
      <div className="education__course__modules__list">
        {modules?.map(module => (
          <ModuleSection
            key={module.id}
            name={module.name}
            courseId={courseId}
            moduleId={module.id}
            lessons={module.EducationLessons}
            onSave={onCreated}
            onClick={() => setIsNewModuleModalOpen({ isOpen: true, moduleData: { name: module.name, id: module.id } })}
            onDelete={() => setIsDeleteModalOpen({ isOpen: true, moduleId: module.id })}
          />
        ))}
      </div>

      <NewModuleModal
        isOpen={isNewModuleModalOpen.isOpen}
        onClose={() => setIsNewModuleModalOpen({ isOpen: false, moduleData: null })}
        courseId={courseId}
        onCreated={onCreated}
        moduleData={isNewModuleModalOpen.moduleData}
      />
      <DeleteModal
        isOpen={isDeleteModalOpen.isOpen}
        onClose={() => setIsDeleteModalOpen({ isOpen: false, moduleId: null })}
        onDelete={() => handleDeleteModule(isDeleteModalOpen.moduleId)}
        title="Delete Module"
        message="Are you sure you want to delete this module? This action will delete all the lessons associated with this module."
      />
    </div>
  );
};

export default ModulesSection;
